import lupa from './Icon awesome-search.svg'
import './searchRack.css'

export function SearchRack(props) {
    function searchHandler({ target }) {
        // Atualiza o termo de busca via `props.onSearch`, deixando o controle para o componente pai
        props.onSearch(target.value);
    }

    return (
        <div style={props.style} className='content-input-search'>
            <img src={lupa} alt='lupa' />
            <input onChange={searchHandler} className='montserrat' type='text' placeholder={props.placeholder} />
        </div>
    );
}